import { Product, ProductVariant } from "@/types/product-type";

export const toQuantity = (value?: number | string | bigint | null) => {
  if (value === null || value === undefined) {
    return 0;
  }
  if (typeof value === "bigint") {
    return Number(value);
  }
  if (typeof value === "string") {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : 0;
  }
  if (typeof value === "number") {
    return Number.isFinite(value) ? value : 0;
  }
  return 0;
};

export const getStockSnapshot = (variant: ProductVariant, product: Product) => {
  // Get stock values from variant.stock (matching Stock type structure)
  const closingQty = toQuantity(variant.stock?.closingQty);
  const openQty = toQuantity(variant.stock?.openQty);
  const soldQty = toQuantity(variant.stock?.soldQty);
  const stockInHand = toQuantity(variant.stock?.stockInHand);

  // Sold quantity: use soldQty from stock, fallback to variant.sold or product.sold
  const sold = Math.max(
    0,
    soldQty || toQuantity(variant.sold ?? product.sold ?? 0)
  );

  // Remaining stock: closingQty is the current available stock (matches stock response)
  const remain = Math.max(0, closingQty);

  // Total stock: use openQty if available (for progress calculation)
  // Otherwise calculate from closingQty + soldQty, or use stockInHand/closingQty
  const total = Math.max(
    0,
    openQty > 0
      ? openQty
      : closingQty > 0 && soldQty > 0
      ? closingQty + soldQty
      : stockInHand > 0
      ? stockInHand
      : closingQty > 0
      ? closingQty
      : toQuantity(variant.quantity ?? product.quantity ?? 0)
  );

  return {
    total,
    sold,
    remain,
  };
};
